/**
 * User Helper Utilities
 * Shared functions for user data formatting and display
 */

/**
 * Formats a user object into a display name
 * Handles multiple name field formats (camelCase and snake_case)
 * @param {Object} user - User object with name fields
 * @returns {string} Formatted user display name
 */
export function formatUserName(user) {
  if (!user) return 'Unknown User'

  // Try camelCase format (firstName, lastName)
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`
  }

  // Try snake_case format (first_name, last_name)
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`
  }

  // Try single name field
  if (user.name) {
    return user.name
  }

  // Fallback to email or username
  return user.email || user.username || 'Unknown User'
}

/**
 * Formats user initials from a user object
 * @param {Object} user - User object with name fields
 * @returns {string} User initials (e.g., "JD" for John Doe)
 */
export function formatUserInitials(user) {
  if (!user) return '?'

  const name = formatUserName(user)
  const parts = name.split(' ')

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }

  return name.substring(0, 2).toUpperCase()
}
